import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild
} from '@angular/core'
import { GridContainer, LinkModel, VideoPlayerCard, ViewComponent } from '@flocasts/experience-service-types'
import { isCardModel } from 'src/app/shared/functions/type-guards'
import { trackById } from 'src/app/shared/utility-functions/track-by-id.utility'

@Component({
  selector: 'flo-grid-container',
  templateUrl: './grid-container.component.html',
  styleUrls: ['./grid-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GridContainerComponent {
  @Input()
  container: GridContainer

  @Input()
  selectedItem: VideoPlayerCard | undefined

  @Output()
  nextPage = new EventEmitter<LinkModel>()

  public emitNextPage(link: LinkModel) {
    this.nextPage.emit(link)
  }

  private _videoPlayerContainer: HTMLElement | undefined
  @ViewChild('videoPlayer', { read: ElementRef })
  set videoPlayerContainer(videoPlayerContainer: ElementRef<HTMLElement>) {
    if (videoPlayerContainer?.nativeElement) {
      this._videoPlayerContainer = videoPlayerContainer.nativeElement
    }
  }

  public emitCardClick(item: ViewComponent) {
    if (isCardModel(item)) {
      this._videoPlayerContainer?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      })
    }
  }

  public trackById = trackById
}
